import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BsModalRef } from "ngx-bootstrap/modal";

import { DateHandlerService } from '../../commons/date-handler.service';
import { RefillsHandlerService } from "../../api-handlers/refills-handler.service";

@Component({
  selector: "edit-refill-modal",
  templateUrl: "./edit-refill-modal.component.html",
  styleUrls: ["./edit-refill-modal.component.css"],
})
export class EditRefillModalComponent implements OnInit {
  errorMessage: string = "";
  saveChangesErrorMessage: string = "";
  refillId?: number;
  km?: string;
  quantity?: string;
  amount?: string;
  fuel_level?: number;
  made_at?: Date;
  fotoBox?: any;
  fotoRecive?: any;
  plate?: string;

  initialDate: Date | null = null;

  updateRefillForm: FormGroup;
  didUserEdit = false;
  modelSubmitted = false;

  @ViewChild("cnvsBox", { static: false }) cnvsBox: ElementRef;
  @ViewChild("cnvsRec", { static: false }) cnvsRec: ElementRef;

  fotoBoxBlob?: string;
  fotoReciveBlob?: string;
  box_url64: string = "";
  recive_url64: string = "";
  willUserEditBox: boolean = false;
  willUserEditRecit: boolean = false;
  fotoBoxReadyForUpload: boolean = true;
  fotoRecitReadyForUpload: boolean = true;

  fotoURI: string = "http://127.0.0.1:8000/api/downloads/image/";

  get getRefillFormControls() {
    return this.updateRefillForm.controls;
  }

  constructor(
    public bsModalRef: BsModalRef,
    private changeDetector: ChangeDetectorRef,
    private dateHandlerService: DateHandlerService,
    private formBuilder: FormBuilder,
    private refillsService: RefillsHandlerService
  ) {}

  ngOnInit(): void {
    this.initialDate = this.made_at;

    this.updateRefillForm = this.formBuilder.group({
      fuel_level: [this.fuel_level, Validators.required],
      quantity: [this.quantity, [Validators.required, Validators.minLength(1)]],
      amount: [this.amount, [Validators.required, Validators.minLength(1)]],
      km: [
        this.km,
        [Validators.required, Validators.minLength(1), Validators.maxLength(6)],
      ],
    });

    this.changeDetector.detectChanges();
    this.startLoading();
    this.getImages();
  }

  onAnyValueChange($event) {
    this.didUserEdit = false;

    if (this.getRefillFormControls.fuel_level.value !== this.fuel_level) {
      this.didUserEdit = true;
    }

    if (this.getRefillFormControls.quantity.value != this.quantity) {
      this.didUserEdit = true;
    }

    if (this.getRefillFormControls.amount.value != this.amount) {
      this.didUserEdit = true;
    }

    if (this.getRefillFormControls.km.value != this.km) {
      this.didUserEdit = true;
    }

    if (
      $event &&
      typeof $event === "object" &&
      $event.getTime() !== this.initialDate.getTime()
    ) {
      this.didUserEdit = true;
    }

    if (
      $event &&
      typeof $event !== "object" &&
      this.made_at.getTime() !== this.initialDate.getTime()
    ) {
      this.didUserEdit = true;
    }

    this.changeDetector.detectChanges();
  }

  getImages() {
    this.refillsService
      .getImage(this.fotoURI + this.fotoBox)
      .then((res) => {
        this.fotoBoxBlob = res;
      })
      .catch((error) => {
        this.errorMessage = "Errore tecnico con l'immagine cruscotto";
      });

    this.refillsService
      .getImage(this.fotoURI + this.fotoRecive)
      .then((res) => {
        this.fotoReciveBlob = res;
      })
      .catch((error) => {
        this.errorMessage = "Errore tecnico con l'immagine ricevuta";
      });
  }

  changeBoxFotoOnClick() {
    this.didUserEdit = true;
    this.willUserEditBox = true;
    this.fotoBoxReadyForUpload = false;
  }

  changeRecitFotoOnClick() {
    this.didUserEdit = true;
    this.willUserEditRecit = true;
    this.fotoRecitReadyForUpload = false;
  }

  changeBoxPhoto() {
    this.fotoBoxBlob = undefined;
    this.box_url64 = "";
  }

  changeRecivePhoto() {
    this.fotoReciveBlob = undefined;
    this.recive_url64 = "";
  }

  startLoading() {
    this.recive_url64 = "";
    this.box_url64 = "";
  }

  drawPictureBox(toDraw: any, widthToSet, heightToSet) {
    const canvas = <HTMLCanvasElement>document.getElementById("cnvsBox");
    const ctx = canvas.getContext("2d");

    canvas.height = heightToSet;
    canvas.width = widthToSet;

    ctx.drawImage(toDraw, 0, 0, canvas.width, canvas.height);

    const contentType = "image/png";
    this.box_url64 = canvas.toDataURL(contentType);
    this.fotoBox = this.dataURItoBlob(this.box_url64);
    this.didUserEdit = true;
    this.fotoBoxReadyForUpload = true;
  }

  drawPictureRec(toDraw: any, widthToSet, heightToSet) {
    const canvas = <HTMLCanvasElement>document.getElementById("cnvsRec");
    const ctx = canvas.getContext("2d");

    canvas.height = heightToSet;
    canvas.width = widthToSet;

    ctx.drawImage(toDraw, 0, 0, canvas.width, canvas.height);

    const contentType = "image/png";
    this.recive_url64 = canvas.toDataURL(contentType);
    this.fotoRecive = this.dataURItoBlob(this.recive_url64);
    this.didUserEdit = true;
    this.fotoRecitReadyForUpload = true;
  }

  deletePicBox() {
    this.fotoBoxReadyForUpload = false;
    this.box_url64 = "";
  }

  deletePicRecive() {
    this.fotoRecitReadyForUpload = false;
    this.recive_url64 = "";
  }

  dataURItoBlob(dataURI) {
    const binary = atob(dataURI.split(",")[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: "image/jpg",
    });
  }

  imageBoxLoaded(event) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event2) => {
        const image = new Image();
        image.onload = () => {
          const canvas = <HTMLCanvasElement>document.getElementById("cnvsBox");
          const hegihtToSet = (canvas.width * image.height) / image.width;
          this.drawPictureBox(image, canvas.width, hegihtToSet);
        };
        image.src = event2.target["result"] as string;
      };
      reader.readAsDataURL(event.target.files[0]);
      event.target.value = null;
    }
  }

  imageRecLoaded(event) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event2) => {
        const image = new Image();
        image.onload = () => {
          const canvas = <HTMLCanvasElement>document.getElementById("cnvsRec");
          const hegihtToSet = (canvas.width * image.height) / image.width;
          this.drawPictureRec(image, canvas.width, hegihtToSet);
        };
        image.src = event2.target["result"] as string;
      };
      reader.readAsDataURL(event.target.files[0]);
      event.target.value = null;
    }
  }

  shouldDisableSubmit(): boolean {
    return (
      !this.didUserEdit ||
      !this.fotoBoxReadyForUpload ||
      !this.fotoRecitReadyForUpload
    );
  }

  async onUpdateRefillSubmit() {
    this.modelSubmitted = true;

    const newBoxFoto = typeof this.fotoBox === "object";
    const newRecitFoto = typeof this.fotoRecive === 'object';

    const formData: FormData = new FormData();
    formData.append('refill_id', this.refillId.toString());
    formData.append('kilometers', this.getRefillFormControls.km.value.toString());
		formData.append('quantity', this.getRefillFormControls.quantity.value.toString());
		formData.append('amount', this.getRefillFormControls.amount.value.toString());
		formData.append("fuel_level", this.getRefillFormControls.fuel_level.value.toString());
		formData.append("made_at", this.dateHandlerService.formatDate(this.made_at));

    if (newBoxFoto) {
			formData.append('box_pic', this.fotoBox);
    }

    if (newRecitFoto) {
			formData.append('recive_pic', this.fotoRecive);
    }

    this.refillsService
      .updateRefill(formData)
      .then((res) => {
        if (res) {
          this.bsModalRef.hide();
        } else {
          this.saveChangesErrorMessage = "Modifiche non effettuate. Prova ancora"
        }
      })
      .catch((error) => {
        this.saveChangesErrorMessage = "Errore con il cambiamento. Prova più tardi oppure contatta gli amministratori"
      });
  }
}
